export const ASSESSMENT_SUPERCATEGORY = {
    compliance: "Compliance",
    security: "Security",
    threats: "Threats",
};
export const ASSESSMENT_SUPERCATEGORY_TYPES = {
    compliance: ["licenses", "secrets"],
    security: ["vulnerabilities", "hardening"],
    threats: ["tampering", "malware"],
};
export const ASSESSMENT_CATEGORY_ORDER = [
    "licenses",
    "secrets",
    "vulnerabilities",
    "hardening",
    "tampering",
    "malware",
];
export const ALL_RISKS_PASSED_LABEL = "Everything is awesome!";
//# sourceMappingURL=assessment.js.map